module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface001#pre1"
    }
  }, [_vm._v("Preface to the Revised Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "pre2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface002#pre2"
    }
  }, [_vm._v("Preface to the First Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part001#pt001"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("I:"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("THE SYNOPTIC GOSPELS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("John the Baptist")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Need of the Kingdom")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Kingdom of God")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The New Age of Salvation")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The God of the Kingdom")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Mystery of the Kingdom")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Kingdom and the Church")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Ethics of the Kingdom")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Messiah")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Son of Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Son of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Messianic Problem")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Messianic Mission")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Eschatology")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Matthew, Mark, and Luke (R. T. France)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space015"
  }, [_vm._v("II:"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("THE FOURTH GOSPEL")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017#ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Critical Problem")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Johannine Dualism")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019#ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Christology")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Eternal Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Christian Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022#ch022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Holy Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter023#ch023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Eschatology")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III:"), _c('span', {
    staticClass: "space"
  }, [_vm._v("THE PRIMITIVE CHURCH")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter024#ch024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Critical Problem")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter025#ch025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Resurrection of Jesus")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter026#ch026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Eschatological Kerygma")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter027#ch027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part004#pt004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV:"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("PAUL")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter028#ch028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter029#ch029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Sources of Paul’s Thought")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-030"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter030#ch030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Humanity outside of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter031#ch031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Person of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-032"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter032#ch032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Work of Christ: Atonement")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-033"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter033#ch033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Work of Christ: Justification")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-034"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter034#ch034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Pauline Psychology")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-035"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter035#ch035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The New Life in Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-036"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter036#ch036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-037"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter037#ch037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Christian Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-038"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter038#ch038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-039"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter039#ch039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Eschatology")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part005#pt005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space025"
  }, [_vm._v("V:"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("HEBREWS AND THE GENERAL EPISTLES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-040"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter040#ch040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Hebrews")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-041"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter041#ch041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("James")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-042"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter042#ch042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("1 Peter")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-043"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter043#ch043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("2 Peter and Jude")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-044"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter044#ch044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Johannine Epistles")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part006#pt006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI:"), _c('span', {
    staticClass: "space"
  }, [_vm._v("THE APOCALYPSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-045"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter045#ch045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Apocalypse")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch-046"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter046#ch046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Appendix: Unity and Diversity in the New Testament (David Wenham)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_vm._v("Indexes")]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bible and Other Ancient Writings")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index003#idx003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subjects")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0